


export const EmailTemplate_START = 'EmailTemplate_START';
export const EmailTemplate_END = 'EmailTemplate_END';
export const EmailTemplate_ERROR = 'EmailTemplate_ERROR';
export const EmailTemplate_SUCCESS = 'EmailTemplate_SUCCESS';
export const EmailTemplate_FAIL = 'EmailTemplate_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully'